import styles from './generate-purchase-order-button.module.css'

export const generateContainerClasses = (isOpen: boolean, isValid: boolean) => {
  return `${!isValid ? styles.invalid : ''} ${styles.container} ${isOpen ? styles.open : ''} `
}

export const generateMessageClasses = (isValid: boolean) => {
  return `${isValid ? styles['message-visible'] : ''} ${styles.message}`
}
